<template src="./SubClients.html"></template>

<script>
import { getSubClients } from '../../../services'

export default {
  name: 'SubClients',
  props: {
    value: [String, Object],
    change: Function,
    focus: Boolean,
    isRequired: Boolean,
    returnObject: {
      type: Boolean,
      default: false
    },
    compliance: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: [String, Number],
      default: null
    }
  },
  model: {
    prop: 'value',
    event: 'update'
  },
  data: () => ({
    subclients: [],
    rules: []
  }),
  created () {
    this.listSubClients()
  },
  mounted () {
    if (this.focus) this.$refs.subclients.$refs.input.focus()
    if (this.isRequired) this.rules = [(val) => !!val]
  },
  methods: {
    async listSubClients () {
      try {
        this.subclients = await getSubClients(this.companyId)
        if (!this.compliance && this.subclients.length === 1) {
          this.$emit('update', this.subclients[0].id)
          this.changeValue(this.subclients[0].id)
        }
      } catch (err) {
        console.log('List subclients:', err)
      }
    },
    changeValue (e) {
      if (this.change) this.change(e)
    }
  }
}
</script>
